export const LOAD_CAMPAIGN_LIST = 'load_campaign_list';
export const LOAD_CAMPAIGN_LIST_FAILURE = 'load_campaign_list_failure';
export const LOAD_CAMPAIGN_LIST_SUCCESS = 'load_campaign_list_success';
export const UPDATE_SELECTED_CAMPAIGN = 'update_selected_campaign';
